export const DeviceUtil = {
  isTouchInputSupported: () => 'ontouchstart' in window,
};
